import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入组件


import index from '../views/index.vue'
import mine from '../views/mine.vue'


/* 配置路由 */
const routes =[
	
	{                    //每一个链接都是一个对象
	  path: '/index',         //链接路径
	  name: 'index',     //路由名称，
	  component: index   //对应的组件模板
	},
{                    //每一个链接都是一个对象
	  path: '/mine',         //链接路径
	  name: 'mine',     //路由名称，
	  component: mine   //对应的组件模板
	},
	  
	{path:'/',name:'index',component:index},
	{
		path: '/mine',
		component: () => import('@/views/mine.vue'),
	
	  },
]
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter)



var router =  new VueRouter({
	linkActiveClass: 'on',
	  linkExactActiveClass: 'on',

    // mode: 'history',
    routes
})
export default router